import { CommitmentSummaryItem } from '../commitment-summary-item.model';
import { ScheduleEventFormValue } from '../schedule-event/schedule-event.form';

export enum EventFormAction {
    NEW = 'new',
    NEWWITHSLOT = 'newSlot',
    UPDATE = 'update',
    CANCEL = 'cancel',
}

export enum EventType {
    OBSERVATION = 1,
    COMMITMENT,
}

export interface EventParticipant {
    firstName?: string;
    userId?: number;
    eventId?: number;
    participantRoleId?: ScheduleEventParticipantRole;
    acceptanceStatusId?: ScheduleEventAcceptanceStatus;
    updatedBy?: number;
    updatedOn?: Date;
}

// create/update schedule event
export interface ScheduleEvent {
    eventId: number;
    eventDate?: Date;
    duration?: number;
    eventName?: string;
    eventTypeId?: EventType;
    description?: string;
    reminders?: any;
    attributes?: any;
    createdBy?: number;
    createdOn?: Date;
    updatedBy?: number;
    updatedOn?: Date;
    eventStatusId?: ScheduleEventStatus;

    participants: EventParticipant[];
    commitments: number[];
}

export enum ScheduleEventParticipantRole {
    ORGANIZER = 1,
    REQUIRED_PARTICIPANT,
    OPTIONAL_PARTICIPANT,
}

export enum ScheduleEventAcceptanceStatus {
    NO_RESPONSE = 0,
    ACCEPTED,
    REJECTED,
    TENTATIVE,
}

export enum ScheduleEventStatus {
    DRAFT = 1, // TODO: unused temporarily
    ACTIVE,
    CANCELLED = 3,
}

export function eventFormTransformer(
    model: ScheduleEvent,
): ScheduleEventFormValue {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const date = new Date(`${model.eventDate}Z`);
    const startDate = date;
    // calculate endDate
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const endDate = new Date(`${model.eventDate}Z`);
    endDate.setMinutes(date.getMinutes() + model.duration);

    let commitmentItems: CommitmentSummaryItem[];
    // eslint-disable-next-line prefer-const
    commitmentItems = model.commitments.map((c) => {
        const commitment: CommitmentSummaryItem = {
            commitmentId: c,
            goals: [],
        };

        return commitment;
    });

    return {
        eventId: model.eventId,
        eventTypeId: model.eventTypeId,
        eventStatusId: model.eventStatusId,
        date,
        participants: model.participants || [],
        commitments: commitmentItems || [],
        startTime: startDate,
        endTime: endDate,
    };
}

// export function scheduleEventFormValueReverseTransformer(model: ScheduleEventFormValue): ScheduleEvent {

//     let duration = 0;
//     let date = null;

//     if (model.date) {
//         date = new Date(model.date);

//         if (model.startTime) {
//             date.setHours(model.startTime.getHours());
//             date.setMinutes(model.startTime.getMinutes());

//             if (model.endTime) {
//                 // round up to the minute
//                 duration = Math.ceil(((model.endTime.getTime() - model.startTime.getTime()) / 1000) / 60);
//             }
//         }
//     }

//     return {
//         eventId: model.eventId || 0,
//         eventTypeId: model.eventTypeId,
//         eventDate: date,
//         participants: model.participants || [],
//         commitments: model.commitments ? model.commitments.map((c: CommitmentSummaryItem) => c.commitmentId) : [],
//         eventStatusId: ScheduleEventStatus.ACTIVE, // TODO: when field is changeable, use passed model
//         duration
//     } as ScheduleEvent
// }
